import { z } from 'zod';

export const AddOnsRequestSchema = z.object({
  planGroupId: z.number(),
  planId: z.number(),
  currencyCode: z.string(),
  includePurchased: z.boolean(),
});

export type AddOnsRequest = z.infer<typeof AddOnsRequestSchema>;

const AddOnsPriceTierSchema = z.object({
  ratePlanId: z.null(),
  currencyCode: z.string(),
  tier: z.number(),
  tierMin: z.number(),
  tierMax: z.number(),
  upperLimit: z.boolean(),
  price: z.number(),
  prorate: z.nullable(z.unknown()),
  pricingModel: z.string(),
  forceUpgrade: z.nullable(z.unknown()),
  pricingQualifier: z.nullable(z.unknown()),
  description: z.string(),
});

const AddOnSchema = z.object({
  id: z.string(),
  name: z.string(),
  linePrice: z.number(),
  available: z.boolean(),
  allowedToPurchase: z.boolean(),
  allowed: z.boolean(),
  purchased: z.boolean(),
  included: z.boolean(),
  availableByPartner: z.boolean(),
  usageType: z.string(),
  priceTiers: z.array(AddOnsPriceTierSchema),
});

const StatusInfoSchema = z.object({
  family: z.string(),
  statusCode: z.number(),
  reasonPhrase: z.string(),
});

export const CancelAddonServiceSchema = z.object({
  status: z.number(),
  entity: z.unknown().nullable(),
  entityAnnotations: z.unknown().nullable(),
  metadata: z.record(z.unknown()),
  outMessage: z.string().nullable(),
  cookies: z.record(z.unknown()),
  length: z.number(),
  language: z.string().nullable(),
  location: z.string().nullable(),
  lastModified: z.string().nullable(),
  date: z.string().nullable(),
  headers: z.record(z.unknown()),
  mediaType: z.string().nullable(),
  allowedMethods: z.array(z.string()),
  statusInfo: StatusInfoSchema,
  entityTag: z.string().nullable(),
  links: z.array(z.string()),
  stringHeaders: z.record(z.string()),
  actualEntity: z.unknown().nullable(),
});

export type CancelAddonService = z.infer<typeof CancelAddonServiceSchema>;

export const AddOnsResponseSchema = z.array(AddOnSchema);

export type AddOnsResponse = z.infer<typeof AddOnsResponseSchema>;

export type AddOnsResponseAddOn = z.infer<typeof AddOnSchema>;

export type AddOnsResponseAddOnPriceTier = z.infer<typeof AddOnsPriceTierSchema>;
